import {inject, Injectable} from '@angular/core';
import {baseUrl} from "../constants/base-url";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class UserPreferencesApiService {
  private http: HttpClient = inject(HttpClient);

  public saveConfiguration(key: string, value: string): Observable<{value: string}> {
    const updateReferencesOptions = {
      key: key,
      value: value
    }

    return this.http.post<{value: string}>(`${baseUrl}/ui-configuration`, updateReferencesOptions);
  }

  public clearConfiguration(key: string): Observable<void> {
    const updateReferencesOptions = {
      key: key,
    }

    return this.http.post<void>(`${baseUrl}/ui-configuration`, updateReferencesOptions);
  }
}
